import { parseAccount } from '@drama/contracts'

/**
 * @typedef {import('@drama/contracts/platform').AccountT} Account
 */

/**
 * account 域：个人资料读写。
 * @param {ReturnType<import('../transport.js').createTransport>} transport
 */
export function createAccountApi(transport) {
  return {
    /**
     * @returns {Promise<Account>}
     */
    getProfile() {
      return transport.request('GET', '/api/sk/account/profile', { parse: parseAccount })
    },

    /**
     * @param {Partial<Account>} patch
     * @returns {Promise<Account>}
     */
    updateProfile(patch) {
      return transport.request('PATCH', '/api/sk/account/profile', {
        body: patch,
        parse: parseAccount,
      })
    },
  }
}
